'use client';
import React, { forwardRef } from 'react';
import SolidTab from './SolidTab.mjs';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

/**
 * LineTab 다음으로 페이지 단위의 탭
 *
 * ### Features
 * - 탭 개수 : 2개, 3개, 4개, 5개 중 택 1
 */
const SolidTabFlexible = /*#__PURE__*/forwardRef((props, ref) => {
  useApplyLogging('SolidTabFlexible');
  return /*#__PURE__*/React.createElement(SolidTab, {
    ...props,
    typeLayout: "flexible",
    ref: ref
  });
});
SolidTabFlexible.displayName = 'SolidTabFlexible';

export { SolidTabFlexible as default };
